<template>
<div>
    <div v-if="texts != null">
        <section v-for="(t, idx) in texts" :key="idx" v-html="t" class="content u-p1" >
            
        </section>
    </div>

</div>
</template>

<script>

import axios from 'axios'
import * as marked from 'marked'
import DOMPurify from 'dompurify'
import * as matter from 'gray-matter'
export default {
    name: 'HotelMainText',
    data() {
        return {
            texts: null
        }
    },
    props: {
        contactid: Number,
    },
    watch:{
        async contactId(){
            await this.refresh()
        }
    },
    async mounted(){
        if(this.contactid){
            await this.refresh()
        }
    },
    methods: {
        async refresh() {
            const { data } = await axios({
                method: 'get',
                url: `https://assets.urlaubsgutschein.kaufen/text/by-tags/HotelId%3A${this.contactid};MainPage%3Atrue/de`,
            })
            if(data && data.length > 0){
                this.texts = []
            }else {
                this.texts = null
            }
            for(let text of data){
                let frontMatter = matter(text)
                const clean = DOMPurify.sanitize(frontMatter.content)
                this.texts.push( marked(clean))
            }
        }
    }

}
</script>

<style scoped lang="scss"></style>
